import { create } from "zustand";
import { persist } from "zustand/middleware";
import { z } from "zod";
import { DocumentTab } from "@/components/content-sidebar/document-sidebar/document-tab-triggers";

const documentTabSchema = z.nativeEnum(DocumentTab);

const persistedStateSchema = z.object({
  lastUsedTab: documentTabSchema.nullable(),
});

type DocumentSidebarTabStore = {
  lastUsedTab: DocumentTab | null;
  setLastUsedTab: (tab: DocumentTab) => void;
};

const useDocumentSidebarTabStore = create<DocumentSidebarTabStore>()(
  persist(
    (set) => ({
      lastUsedTab: null,
      setLastUsedTab: (lastUsedTab) => set({ lastUsedTab }),
    }),
    {
      name: "document-sidebar-tab-storage",
      merge: (persistedState, currentState) => {
        const parsed = persistedStateSchema.safeParse(persistedState);
        if (!parsed.success) {
          return currentState;
        }
        return {
          ...currentState,
          lastUsedTab: parsed.data.lastUsedTab,
        };
      },
    }
  )
);

export default useDocumentSidebarTabStore;
